import { useState, useEffect } from 'react';

interface HealthResponse {
  status: string;
  message: string;
  timestamp: string;
  version: string;
}

interface UseServerHealthReturn {
  serverStatus: HealthResponse | null;
  isLoading: boolean;
  error: string | null;
}

export const useServerHealth = (): UseServerHealthReturn => {
  const [serverStatus, setServerStatus] = useState<HealthResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkServerHealth = async () => {
      try {
        const response = await fetch('https://vikings.tenb.uk/api/health');
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data: HealthResponse = await response.json();
        setServerStatus(data);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to connect to server');
        setServerStatus(null);
      } finally {
        setIsLoading(false);
      }
    };

    checkServerHealth();
  }, []);

  return {
    serverStatus,
    isLoading,
    error,
  };
};